import BaseAutocompleteList from "./BaseAutocompleteList.vue";

export type {
  AutocompleteListProps,
  AutoCompleteOption,
  GenericOption,
} from "./BaseAutocompleteList.vue";
export { isOptionObject } from "./BaseAutocompleteList.vue";
export default BaseAutocompleteList;
